/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail200,
  GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail400,
  GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail401,
  GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail500,
  GetApiV1CourseregistrationCourseregistrationidSharedPoloDetailPathParams,
  GetApiV1CourseregistrationCourseregistrationidSharedPoloDetailQueryResponse,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail.ts";
import { courseRegistrationPoloDetailViewModelSchema } from "../courseRegistrationPoloDetailViewModelSchema.ts";

export const getApiV1CourseregistrationCourseregistrationidSharedPoloDetailPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseregistrationCourseregistrationidSharedPoloDetailPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseregistrationCourseregistrationidSharedPoloDetail200Schema =
  z.lazy(
    () => courseRegistrationPoloDetailViewModelSchema,
  ) as unknown as ToZod<GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail200>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const getApiV1CourseregistrationCourseregistrationidSharedPoloDetail400Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseregistrationCourseregistrationidSharedPoloDetail401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseregistrationCourseregistrationidSharedPoloDetail500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseregistrationCourseregistrationidSharedPoloDetail500>;

export const getApiV1CourseregistrationCourseregistrationidSharedPoloDetailQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1CourseregistrationCourseregistrationidSharedPoloDetail200Schema,
  ) as unknown as ToZod<GetApiV1CourseregistrationCourseregistrationidSharedPoloDetailQueryResponse>;
